import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import { calculateBundleTotal, getConsigneeData } from "../../../../common/utils/apis";
import {
  getPdmApiUrl,
  getLoggedInUserInfo,
  getPurchaseApiUrl,
  getCommonParameters,
} from "../../../../common/utils/helper";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";
import { getVisitorStatus } from "@tw/header-footer/lib/utils/helper";
import { USER_ALL_PROMOTIONS_LIST, POINTS_CATEGORY_CODE } from "@tw/shared-ui-components/lib/utils/Constants/Constants"
const LoggedInUserRole = getLoggedInUserInfo().role;
const SET_PLP_STATE = "SET_PLP_STATE";
const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
const APPEND_PRODUCT_LIST = "APPEND_PRODUCT_LIST";
const SET_SORTING_DETAILS = "SET_SORTING_DETAILS";
const SET_FILTER_DETAILS = "SET_FILTER_DETAILS";
const SET_SELECTED_PROMOTION = "SET_SELECTED_PROMOTION";
const SET_PROMOTION_BUNDLE_TOTAL = "SET_PROMOTION_BUNDLE_TOTAL";
const RESET_PROMOTION_DETAILS = "RESET_PROMOTION_DETAILS";
const SET_LOADING = "SET_LOADING";
const SET_LIST_LOADER = "SET_LIST_LAODER";
const SET_FOOTER_LOADER = "SET_FOOTER_LOADER";
const SET_STATIC_PAGE_DATA = "SET_STATIC_PAGE_DATA";
const MARKUP_PURCHASE_LIST = "MARKUP_PURCHASE_LIST";
const GENERIC_ERR_MSG = '暫時無法處理您的請求，請稍後再試';
const getUserAllPromotionsList = () => {
  if (typeof window !== 'undefined' && typeof window !== undefined) {
    const PROMOTIONS_LIST = localStorage.getItem(USER_ALL_PROMOTIONS_LIST) ? JSON.parse(localStorage.getItem(USER_ALL_PROMOTIONS_LIST)) : []
    return PROMOTIONS_LIST.map((item) => item.activityCode)
  }
}
export const setMarkupPurchaseList = (state) => {
  return {
    type: MARKUP_PURCHASE_LIST,
    payload: state,
  };
}
export const setPlpState = (state) => {
  return {
    type: SET_PLP_STATE,
    payload: state,
  };
};

export const setProductList = (state) => {
  return {
    type: SET_PRODUCT_LIST,
    payload: state,
  };
};

export const setFilterDetails = (state) => {
  return {
    type: SET_FILTER_DETAILS,
    payload: state,
  };
};

export const setSortingDetails = (state) => {
  return {
    type: SET_SORTING_DETAILS,
    payload: state,
  };
};

export const appendProductList = (state) => {
  return {
    type: APPEND_PRODUCT_LIST,
    payload: state,
  };
};

export const setBundleTotal = (state) => {
  return {
    type: SET_PROMOTION_BUNDLE_TOTAL,
    payload: state,
  };
};

export const setStaticPageData = (state) => {
  return {
    type: SET_STATIC_PAGE_DATA,
    payload: state,
  };
};
export const toggleCollection =
  (itemCode, pageType) => async (dispatch, getState) => {
    const plpState = getState().plpState.listDetails;
    let newState;
    if (pageType === "promotionPlp") {
      const promotionState = getState().plpState;

      newState = {
        ...promotionState,
        promotionProducts: {
          ...promotionState?.promotionProducts,
          productsData: promotionState?.promotionProducts?.productsData?.map(
            (el) =>
              itemCode === el?.itemCode
                ? { ...el, isCollected: !el.isCollected }
                : el
          ),
        },
      };

      dispatch(setPlpState(newState));
    } else {
      newState = {
        ...plpState,
        content: plpState?.content?.map((el) =>
          itemCode === el.itemCode
            ? { ...el, isCollected: !el.isCollected }
            : el
        ),
      };
      dispatch(setProductList(newState));
    }
  };

export const updateItemQuantity =
  (itemCode, quantity) => async (dispatch, getState) => {
    const plpState = getState().plpState;
    const promotionCode = plpState?.promotionDetails?.promotionCode;

    const promotionItemList = plpState.promotionProducts?.productsData
      ?.map((product) => {
        const quan =
          product.itemCode === itemCode ? quantity : product.quantity;

        return (
          quan && {
            itemCode: product.itemCode,
            quantity: quan,
          }
        );
      })
      .filter(Boolean);

    if (!promotionItemList?.length) {
      return dispatch(resetPromotionDetails());
    }
    try {
      const res = await calculateBundleTotal(promotionCode, promotionItemList);
      if (res?.totalBusinessVolume && res?.totalPointVolume && res?.totalPrice && res?.totalQuantity) {
        dispatch(setBundleTotal(res));
        dispatch({
          type: SET_SELECTED_PROMOTION,
          payload: {
            itemCode,
            quantity,
          },
        });
      } else {
        toastMsg(res?.message);
      }
    } catch (error) {
      toastMsg(error?.response?.data?.message);
      console.log(error);
    }
  };

export const resetPromotionDetails = () => {
  return {
    type: RESET_PROMOTION_DETAILS,
  };
};

export const setLoading = (isLoading) => {
  return {
    type: SET_LOADING,
    payload: isLoading,
  };
};

export const setListLoader = (isLoading) => {
  return {
    type: SET_LIST_LOADER,
    payload: isLoading,
  };
};

export const setFooterLoader = (isLoading) => {
  return {
    type: SET_FOOTER_LOADER,
    payload: isLoading,
  };
};



export const fetchPlpState =
  (param, pageType) => async (dispatch, getState) => {
    try {
      const apiUrl = getPdmApiUrl();
      const state = getState();
      let res;
      let params;
      if (LoggedInUserRole !== "Guest") {
        params = {
          pageNo: 1,
          pageSize: state.breakpoint === "xs" ? 6 : 9,
          role: LoggedInUserRole,
        };
      } else {
        params = {
          pageNo: 1,
          pageSize: state.breakpoint === "xs" ? 6 : 9,
        };
      }
      let plpNewState;
      dispatch(setListLoader(true));
      switch (pageType) {
        case "search":
          params = Object.assign({}, params, {
            sortProperty: 'NEW_PRODUCT_SORT',
            priceSectionType: "MONEY",
          })
          res = await axios.post(
            `/search/searchProducts/${param}`,
            {
              ...params,
            },
            {
              baseURL: apiUrl,
            }
          );
          plpNewState = {
            ...res.data,
            searchResultsCount: res?.data?.listDetails?.totalElements,
          };
          break;
        case "promotionPLP":
          res = await axios.post(
            `/plp/promotions/${param}`,
            {},
            {
              baseURL: apiUrl,
            }
          );
          plpNewState = res.data;
          break;
        case "shopByRedeemPoints":
          res = await axios.post(
            `/plp/shopByRedeemPoints`,
            {
              categoryCode: 9000,
              priceSectionType: "GIFT_POINT",
              excludeTagCodes: ["RENEW"],
              pageNo: 1,
              pageSize: state.breakpoint === "xs" ? 6 : 9,
            },
            {
              baseURL: apiUrl,
            }
          );
          plpNewState = {
            ...res.data,
            pageType: "shopByRedeemPoints",
            displayPoint: true,
            priceSectionType: "GIFT_POINT",
            cardButtonType: CardBtnTypes.REDEEM_POINTS,
          };
          break;
        case "detailsCategory":
          res = await axios.post(
            `/plp/details`,
            {
              type: "category",
              code: param,
            },
            { baseURL: apiUrl }
          );
          plpNewState = res.data;
          break;
        case "detailsPromotion":
          res = await axios.post(
            `/plp/details`,
            {
              type: "promotion",
              code: param,
            },
            {
              baseURL: apiUrl,
            }
          );
          plpNewState = res.data;
          break;
        case "promotion-list":
          res = await axios.post(
            `/plp/promotions`,
            {
              userAllPromotionsList: getUserAllPromotionsList()
            },
            {
              baseURL: apiUrl,
            }
          );
          plpNewState = res.data;
          break;
        case "recommendedProducts":
          res = await axios.post(
            `/recommendProducts`,
            {
              pageNo: 1,
              pageSize: state.breakpoint === "xs" ? 6 : 9,
              sceneType: "FREE_SHIPPING_MAKE_UP",
            },
            {
              baseURL: apiUrl,
            }
          );

          plpNewState = {
            pageType: "freeShipping",
            listDetails: {
              content: res?.data.products,
              totalElements: res?.data?.totalElements,
            },
          };
          break;
        case "markupPurchase": // 加價購
          res = await axios.post(
            `/plp/markupPurchase`,
            {
              itemCodes: param?.itemCodes,
              defaultSku: false,
              onlySearchable: false,
              pageNo: 1,
              pageSize: state.breakpoint === "xs" ? 6 : 9,
              sceneType: "FREE_SHIPPING_MAKE_UP",
              isMarkupPurchase: true
            },
            {
              baseURL: apiUrl,
            }
          );
          plpNewState = {
            pageType: "markupPurchase",
            cardButtonType: CardBtnTypes.MARKUP_PURCHASE,
            listDetails: {
              content: res?.data.content,
              totalElements: res?.data?.totalElements,
            },
          };
          break;
        case "specialPlpForDefaultSku":
          res = await axios.post(
            `/plp/${param}`,
            {
              defaultSku: true,
              ...params,
            },
            { baseURL: apiUrl }
          );
          plpNewState = {
            ...res.data,
            pageType: "specialPlpForDefaultSku",
          };
          break;
        default:
          //TEP-16889
          params = Object.assign({}, params, {
            sortProperty: 'NEW_PRODUCT_SORT',
            priceSectionType: POINTS_CATEGORY_CODE.includes(param) ? "GIFT_POINT" : "MONEY",
          })
          res = await axios.post(
            `/plp/${param}`,
            {
              ...params,
            },
            {
              baseURL: apiUrl,
            }
          );
          plpNewState = res.data;
          break;
      }
      dispatch(setPlpState(plpNewState));
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setListLoader(false));
    }
  };

export const fetchProductList =
  (request, listPageType) => async (dispatch, getState) => {
    try {
      dispatch(setListLoader(true));
      const apiUrl = getPdmApiUrl();
      const state = getState();
      let res;
      let plpNewState;
      const filteringDetails =
        state && state.plpState && state.plpState.filteringOptions;
      const sortingDetails =
        state && state.plpState && state.plpState.sortingOptions;
      let params;
      if (LoggedInUserRole !== "Guest") {
        params = {
          keyword: state.plpState?.keyword,
          categoryCode: state.plpState?.categoryCode,
          // priceType: "MONEY",
          priceSectionType: isPointsPurchase(state.plpState?.categoryCode) ? "GIFT_POINT" : state.plpState.priceSectionType || "MONEY",
          pageNo: 1,
          pageSize: state.breakpoint === "xs" ? 6 : 9,
          role: LoggedInUserRole,
        };
      } else {
        params = {
          keyword: state.plpState?.keyword,
          categoryCode: state.plpState?.categoryCode,
          // priceType: "MONEY",
          priceSectionType: isPointsPurchase(state.plpState?.categoryCode) ? "GIFT_POINT" : state.plpState.priceSectionType || "MONEY",
          pageNo: 1,
          pageSize: state.breakpoint === "xs" ? 6 : 9,
        };
      }
      const pageType = listPageType || state?.plpState?.pageType;

      switch (pageType) {
        case "recommendProducts":
          res = await axios.post(
            `/recommendProducts`,
            {
              pageNo: 1,
              pageSize: state.breakpoint === "xs" ? 6 : 9,
              sceneType: "FREE_SHIPPING_MAKE_UP",
            },
            {
              baseURL: apiUrl,
            }
          );

          plpNewState = {
            pageType: "freeShipping",
            listDetails: {
              content: res?.data.products,
              totalElements: res?.data?.totalElements,
            },
          };

          dispatch(setPlpState(plpNewState));

          break;
        case "shopByRedeemPoints":
          res = await axios.post(
            `/plp/list`,
            {
              pageNo: 1,
              pageSize: state.breakpoint === "xs" ? 6 : 9,
              categoryCode: 9000,
              priceSectionType: state.plpState.priceSectionType,
              excludeTagCodes: ["RENEW"],
              ...getFilteringDetails(filteringDetails),
              ...sortingDetails,
              sortType: sortingDetails?.sortType ?? "ASC",
              sortProperty: sortingDetails?.sortProperty ?? "NEW_PRODUCT_SORT"
            },
            {
              baseURL: apiUrl,
            }
          );

          dispatch(setProductList(res.data));

          break;
        case "specialPlpForDefaultSku":
          if (
            !(
              state.plpState.categoryCode ||
              state.plpState.keyword ||
              state.plpState.priceSectionType
            )
          ) {
            return;
          }
          res = await axios.post(
            `/plp/list`,
            {
              defaultSku: true,
              ...params,
              ...getFilteringDetails(filteringDetails),
              ...sortingDetails,
              ...request,
            },
            {
              baseURL: apiUrl,
            }
          );
          dispatch(setProductList(res.data));

          break;
        default:
          if (
            !(
              state.plpState.categoryCode ||
              state.plpState.keyword ||
              state.plpState.priceSectionType
            )
          ) {
            return;
          }
          res = await axios.post(
            `/plp/list`,
            {
              ...params,
              ...getFilteringDetails(filteringDetails),
              ...{ sortProperty: 'NEW_PRODUCT_SORT', ...sortingDetails },
              ...request,
            },
            {
              baseURL: apiUrl,
            }
          );
          dispatch(setProductList(res.data));
          break;
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setListLoader(false));
    }
  };

export const viewMore = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));
    const apiUrl = getPdmApiUrl();
    const state = getState();
    const filteringDetails =
      state && state?.plpState && state?.plpState?.filteringOptions;
    const sortingDetails =
      state && state?.plpState && state?.plpState?.sortingOptions;

    const pageType = state?.plpState?.pageType;
    let params;
    if (LoggedInUserRole !== "Guest") {
      params = {
        role: LoggedInUserRole,
      };
    } else {
      params = {
      };
    }
    let res;
    switch (pageType) {
      case "freeShipping":
        res = await axios.post(
          `/recommendProducts`,
          {
            pageNo: (state.plpState.listDetails?.pageNo ?? 1) + 1,
            pageSize: state.breakpoint === "xs" ? 6 : 9,
            sceneType: "FREE_SHIPPING_MAKE_UP",
          },
          {
            baseURL: apiUrl,
          }
        );
        dispatch(
          appendProductList({
            content: res?.data?.products,
            totalElements: res?.data?.totalElements,
          })
        );
        break;
      case "shopByRedeemPoints":
        res = await axios.post(
          `/plp/list`,
          {
            pageNo: (state.plpState.listDetails?.pageNo ?? 1) + 1,
            pageSize: state.breakpoint === "xs" ? 6 : 9,
            categoryCode: 9000,
            priceSectionType: state.plpState.priceSectionType,
            excludeTagCodes: ["RENEW"],
            ...getFilteringDetails(filteringDetails),
            ...sortingDetails,
            sortType: sortingDetails?.sortType ?? "ASC",
            sortProperty: sortingDetails?.sortProperty ?? "NEW_PRODUCT_SORT",
            ...params
          },
          {
            baseURL: apiUrl,
          }
        );
        break;
      case "specialPlpForDefaultSku":
        res = await axios.post(
          `/plp/list`,
          {
            pageSize: state.breakpoint === "xs" ? 6 : 9,
            pageNo: (state.plpState.listDetails?.pageNo ?? 1) + 1,
            priceSectionType: state.plpState.priceSectionType || "MONEY",
            keyword: state.plpState.keyword,
            defaultSku: true,
            categoryCode: state.plpState.categoryCode,
            priceType: state.plpState.priceType,
            ...getFilteringDetails(filteringDetails),
            ...sortingDetails,
            ...params
          },
          { baseURL: apiUrl }
        );
        break;

      default:
        res = await axios.post(
          `/plp/list`, //DEFAULT PAGE TYPE
          {
            pageSize: state.breakpoint === "xs" ? 6 : 9,
            pageNo: (state.plpState.listDetails?.pageNo ?? 1) + 1,
            priceSectionType: isPointsPurchase(state.plpState?.categoryCode) ? "GIFT_POINT" : state.plpState.priceSectionType || "MONEY",
            keyword: state.plpState.keyword,
            categoryCode: state.plpState.categoryCode,
            priceType: state.plpState.priceType,
            ...getFilteringDetails(filteringDetails),
            ...{ sortProperty: 'NEW_PRODUCT_SORT', ...sortingDetails },
            ...params
          },
          { baseURL: apiUrl }
        );
    }
    dispatch(appendProductList(res.data));
  } catch (err) {
    console.log(err);
  } finally {
    dispatch(setLoading(false));
  }
};

const getFilteringDetails = (filteringDetails) => ({
  priceSections: filteringDetails.priceSections,
  tagCodes: filteringDetails.tagCodes,
  categoryCodes: filteringDetails.categoryCodes,
});

export const CardBtnTypes = {
  ADD_TO_CART: "ADD_TO_CART",
  ONLY_ADD_TO_CART: "ONLY_ADD_TO_CART",
  REDEEM_POINTS: "REDEEM_POINTS",
  MARKUP_PURCHASE: "MARKUP_PURCHASE"
};

const initialState = {
  cardButtonType: CardBtnTypes.ADD_TO_CART,
  markupPurchaseList: {},
  filteringOptions: {},
  selectedPromotionDetails: {
    totalQuantity: 0,
    totalBusinessVolume: 0,
    totalPointVolume: 0,
    totalPrice: 0,
    selectedProducts: [],
  },
};

let products;

const plpState = (state = initialState, action) => {
  switch (action.type) {
    case SET_PLP_STATE:
      return {
        ...initialState,
        ...action.payload,
      };
    case SET_PRODUCT_LIST:
      return {
        ...state,
        listDetails: action.payload,
      };
    case APPEND_PRODUCT_LIST:
      return {
        ...state,
        listDetails: {
          ...state.listDetails,
          pageNo: (state.listDetails?.pageNo ?? 1) + 1,
          content: [...state?.listDetails?.content, ...action.payload?.content],
        },
      };
    case SET_SORTING_DETAILS:
      return {
        ...state,
        sortingOptions: action.payload,
      };
    case SET_FILTER_DETAILS:
      return {
        ...state,
        filteringOptions: action.payload,
      };
    case SET_SELECTED_PROMOTION:
      products = state.promotionProducts?.productsData?.map((product) => {
        if (product.itemCode !== action.payload.itemCode) return product;
        return {
          ...product,
          quantity: action.payload.quantity,
        };
      });
      return {
        ...state,
        promotionProducts: {
          ...state.promotionProducts,
          productsData: products,
        },
      };

    case SET_PROMOTION_BUNDLE_TOTAL:
      return {
        ...state,
        selectedPromotionDetails: action.payload,
      };
    case RESET_PROMOTION_DETAILS:
      return {
        ...state,
        promotionProducts: {
          ...state.promotionProducts,
          productsData: state.promotionProducts?.productsData?.map(
            (product) => ({
              ...product,
              quantity: 0,
            })
          ),
        },
        ...initialState,
      };
    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_LIST_LOADER:
      return {
        ...state,
        listLoader: action.payload,
      };
    case SET_FOOTER_LOADER:
      return {
        ...state,
        footerLoader: action.payload,
      };
    case SET_STATIC_PAGE_DATA:
      return {
        ...state,
        staticPageData: action.payload,
      };
    case MARKUP_PURCHASE_LIST:
      return {
        ...state,
        markupPurchaseList: action.payload,
      }
    default:
      return state;
  }
};

export const fetchStaticPageData = (pageUrl) => async (dispatch) => {
  const apiUrl = getPdmApiUrl();
  try {
    const res = await axios.post(
      `/staticPageData`,
      {
        pageUrl: pageUrl,
      },
      {
        baseURL: apiUrl,
      }
    );
    dispatch(setStaticPageData(res.data));
  } catch (err) {
    console.log(err);
  }
};



export const removeMiniCart = (body) => async (dispatch) => {
  try {
    const apiUrl = getPurchaseApiUrl();
    const isVisitor = getVisitorStatus();
    const params = body?.consigneeAda && body?.consigneeType && body?.consigneeMemberType ?
      {
        ...body,
        ...getCommonParameters(),
      }
      :
      {
        ...getConsigneeData(),
        ...getCommonParameters(),
        ...body,
      };

    const url = isVisitor ? `/anon/cart/remove-cart-abo` : `/cart/remove-cart-abo`;
    // Show loader
    dispatch(setListLoader(true));
    const res = await axios
      .post(
        url, params,
        { baseURL: apiUrl }
      )
    return {
      ...res.data,
    };
  } catch (error) {
    console.log(error);
  }
};
export const getMarkupPurchaseAddToCart = (body) => async (dispatch) => {
  const apiUrl = getPdmApiUrl();
  try {
    const params = body?.consigneeAda && body?.consigneeType && body?.consigneeMemberType ?
      {
        ...body,
        ...getCommonParameters(),
      }
      :
      {
        ...body,
        ...getConsigneeData(),
        ...getCommonParameters(),
      }
    const res = await axios.post(
      `/plp/markupPurchaseAddToCart`, params,
      {
        baseURL: apiUrl,
      }
    );
    dispatch(setStaticPageData(res.data));
    return res.data
  } catch (err) {
    console.log(err);
  }
};
export const reselectProduct = (body) => async () => {
  const apiUrl = getPdmApiUrl();
  try {
    const params = {
      ...body,
      ...getCommonParameters(),
    }
    const res = await axios.post(
      `/reselectProduct`, params,
      {
        baseURL: apiUrl,
      }
    );
    return res
  } catch (err) {
    console.log(err);
  }
}
export const removeProduct =
  (itemCode, consigneeAda, onAddToCart = null) =>
    async () => {
      console.log("[cartAction] >> [removeProduct]");
      const requestBody = { itemCode };
      const apiUrl = getPurchaseApiUrl();
      const url = `/cart/remove-product`;
      axios
        .post(
          url,
          {
            ...getCommonParameters(),
            ...requestBody,
            consigneeAda,
          },
          { baseURL: apiUrl }
        )
        .then(response => {
          if (response?.status === 200) {
            onAddToCart && onAddToCart()
          } else {
            toastMsg(
              response?.response?.data?.message || GENERIC_ERR_MSG,
              response?.response?.data.details,
              response?.response?.data?.type
            );
          }

        })
    };
//  TEP-16889
export const isPointsPurchase = (categoryCode) => {
  try {
    if (typeof window !== "undefined" && typeof window !== undefined) {
      const pathname = window?.location?.href?.includes('#') ? window?.location?.hash : window?.location?.pathname;
      return POINTS_CATEGORY_CODE.includes(categoryCode) || pathname.includes("shopping-by-redeem-points");
    }
  } catch (error) {
    console.log('isPointsPurchase >> catch:', error);
  }
}
export default {
  plpState,
  removeMiniCart,
  getMarkupPurchaseAddToCart
};
